import React from 'react';
import PropTypes from 'prop-types';
import { Popover, CardHeader, Divider, colors, IconButton } from '@mui/material';
import NotificationList from './NotificationList';
import Placeholder from './Placeholder';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

const styles = {
    root: {
        width: 350,
        maxWidth: '100%'
    },
    actions: {
        backgroundColor: colors.grey[50],
        justifyContent: 'center'
    }
};

const NotificationsPopover = ({
    notifications,
    onClickNotification,
    anchorEl,
    handleDeleteAll,
    ...rest
}) => {

    return (
        <Popover
            {...rest}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
            }}
        >
            <div style={styles.root}>
                <CardHeader sx={styles.header}
                    action={
                        <IconButton color="primary" onClick={handleDeleteAll} disabled={notifications.length === 0}>
                            <DeleteForeverIcon />
                        </IconButton>
                    }
                    title="Bildirimler" />
                <Divider />
                {notifications.length ? (
                    <NotificationList
                        notifications={notifications}
                        onClickNotification={onClickNotification}
                    />
                ) : (
                        <Placeholder />
                    )}
            </div>
        </Popover>
    );
};

NotificationsPopover.propTypes = {
    anchorEl: PropTypes.any,
    className: PropTypes.string,
    notifications: PropTypes.array.isRequired,
    onClickNotification: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
};

export default NotificationsPopover;
